module.exports = __webpack_public_path__ + "static/media/logo-medium.522d8530.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/logo-medium.png
// module id = 952
// module chunks = 0